import { render, staticRenderFns } from "./IndexComplaint.vue?vue&type=template&id=4cc1f50d"
import script from "./IndexComplaint.vue?vue&type=script&lang=js"
export * from "./IndexComplaint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports